'use client';

import { useRef } from 'react';

import { cn } from '@wwe-portal/ui/lib/lib';
import type { StepupOfferCardProps } from '../type';
import { OfferCardStatusEnum } from '../type';

import { LockIcon } from './lock-icon';
import { OfferCard } from './offer-card';

export function StepupCard({
  status,
  overlay,
  ...cardProps
}: StepupOfferCardProps) {
  const ref = useRef<HTMLDivElement>(null);

  return (
    <div ref={ref}>
      <OfferCard
        {...cardProps}
        maxQuantity={undefined}
        overlay={
          <>
            <div className="pointer-events-none absolute inset-0 rounded-b-[10px] border-[1px] border-solid border-[#FFA800]" />
            <div
              className={cn(
                'absolute bottom-[0] left-4 aspect-[29/33] h-[calc(3300%/167)]',
                {
                  'overflow-hidden': status === OfferCardStatusEnum.CLAIMED,
                }
              )}
            >
              <div className="absolute -right-4 -top-[1px] h-full w-7 bg-[url('/assets/images/stepup/offer-order-background.svg')] bg-cover bg-center" />
              <div className="font-poppins absolute inset-x-0 bottom-[calc(600%/33)] top-[calc(700%/33)] flex items-center justify-center text-lg font-semibold leading-6 text-white drop-shadow-[1px_1px_1px_rgba(0,0,0,0.45)]">
                <span className="leading-6">{cardProps.orderId}</span>
              </div>
            </div>

            <LockIcon
              enabled={status === OfferCardStatusEnum.LOCKED}
              orderId={cardProps.orderId}
            />

            {status === OfferCardStatusEnum.CLAIMED && (
              <div className="absolute inset-0 bg-black opacity-75" />
            )}
            {overlay}
          </>
        }
        quantity={undefined}
      />
    </div>
  );
}
